import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { Form, Button, 
    // Icon 
} from "antd";
// import { OrderedMap } from "immutable";
import {
    fieldGenerator,
    getErrorOnField,
    // getValidateStatus,
    submitForm
} from "utilities/form";
import "styles/form.css";
import { AGREEMENT_DETAILS_FORM } from "constants/form-fields";
const FormItem = Form.Item;
class BusinessAgreementDetailsForm extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    handleFormSubmit = submitForm.bind(this.props.form, () => null);

    state = {
        product_list: [],
        showForm: false
    };

    saveAgreementDetails = () => {
        const { form } = this.props;
        form.validateFields((err, values) => {
            let newValues = {
                ...values,
                business_program: this.props.businessProgramId,
                start_date: values.start_date && values.start_date.format("YYYY-MM-DD"),
                end_date: values.end_date && values.end_date.format("YYYY-MM-DD"),
                signing_date: values.signing_date && values.signing_date.format("YYYY-MM-DD")
            };
            this.props.values && this.props.values.get("id") ? this.props.updateAgreementDetails(newValues) : this.props.saveAgreementDetails(newValues);
        });
    }

    render() {
        return (
            <div className={"p-10"}>
                <Form
                    className={cx("form", "br-3")}
                >
                    <div className={"form-row"}>
                        {AGREEMENT_DETAILS_FORM.map((field, fieldName) =>
                            this.fieldGenerator(
                                fieldName,
                                field,
                                this.getErrorOnField(fieldName)
                            )()
                        ).toList()}
                    </div>
                    <div className="d-flex justify-content-flex-end">
                        <FormItem className={cx("mr-5")}>
                            <Button key="save" type="primary" icon={"plus"} onClick={this.saveAgreementDetails}>{this.props.values && this.props.values.get("id") ? "Update" : "Save"}</Button>
                        </FormItem>
                    </div>
                </Form>
            </div>
        );
    }
}

BusinessAgreementDetailsForm.propTypes = {
    form: PropTypes.object,
    saveAgreementDetails: PropTypes.func,
    businessProgramId: PropTypes.number,
    values: PropTypes.object,
    updateAgreementDetails: PropTypes.func,
    parentProgramData: PropTypes.object
};

export default Form.create({
    mapPropsToFields: ({ values, parentProgramData }) => {
        let newValues = values && values.get("id") ? values : parentProgramData;
        return newValues &&
        newValues
            .toSeq()
            .toMap()
            .map((value) => {
                return Form.createFormField({
                    value
                });
            })
            .toJS();
    }
})(BusinessAgreementDetailsForm);